define('lq/navigatorMpa',[
    'lq',
    './navigationHistory'
], function (lq, NavigationHistory) {
    'use strict';
    
    var NavigatorMpa = function (url, friendlyNames) {
        this.url = url;
        this.friendlyNames = friendlyNames;
        this.history = NavigationHistory.withLocalStorage('mpa');
    };

    NavigatorMpa.prototype.openAction = function (actionId, globals, locals, openBlank) {
        this.history.push(window.location.href);

        var route = this.friendlyNames[actionId];

        if (!route)
            route = 'LicquidAction/Get/' + actionId;

        var parameters = {
            globals: JSON.stringify(globals),
            parameters: JSON.stringify(locals)
        };

        var targetUrl = this.url.prepare(lq.getTenantUrl(route), parameters);
        this.url.openUrl(targetUrl, openBlank);
    };

    NavigatorMpa.prototype.goToPrevious = function (parameters) {
        var previousUrl = this.history.pop();
        
        if (previousUrl) {
            var targetUrl = this.url.prepare(previousUrl, parameters);
            this.url.openUrl(targetUrl, false);
        }
    };

    return NavigatorMpa;
});
